<template>
  <sc-card
    :title="title"
    :loading="loadingMargin">

    <template slot="body">

      <form @submit.prevent="saveMargin">
        <sc-field>
          <sc-radio
            v-model="margin.marginType"
            :native-value="null">
            Padrão do sistema
          </sc-radio>
        </sc-field>

        <sc-field>
          <sc-radio
            v-model="margin.marginType"
            native-value="ABSOLUTE"
            class="configuration-invoice__radio">
            Considera dentro da margem, até
          </sc-radio>

          <sc-field>
            <sc-input-currency
              class="input"
              v-model="margin.marginFixedValue"
              :disabled="margin.marginType !== 'ABSOLUTE'" />
          </sc-field>
        </sc-field>

        <sc-field>
          <sc-radio
          v-model="margin.marginType"
            native-value="PERCENTAGE"
            class="configuration-invoice__radio">
            Considera dentro da margem o percentual de
          </sc-radio>

          <sc-field>
            <sc-input-percent
              class="input"
              v-model="margin.marginPercentageValue"
              :disabled="margin.marginType !== 'PERCENTAGE'" />
          </sc-field>
        </sc-field>

        <sc-field>
          <sc-radio
            v-model="margin.marginType"
            native-value="MIXED_GREATER"
            class="configuration-invoice__radio">
            Considera dentro da margem uma das opções
          </sc-radio>

          <sc-field>
            <sc-input-currency
              class="input"
              v-model="margin.marginMixedFixedValue"
              :disabled="margin.marginType !== 'MIXED_GREATER'" />
            <p class="control">
              <span class="button is-static">ou</span>
            </p>
            <sc-input-percent
              class="input"
              v-model="margin.marginMixedPercentageValue"
              :disabled="margin.marginType !== 'MIXED_GREATER'" />
          </sc-field>
        </sc-field>

        <div class="buttons is-right">
          <button
            class="button is-primary"
            :class="{'is-loading': loadingMarginSave}">Salvar</button>
        </div>
      </form>

    </template>

  </sc-card>
</template>

<script>
  import {
    ScField,
    ScInputCurrency,
    ScInputPercent,
    ScRadio,
    ScCard,
  } from '@intelipost-js/secure-components';
  import { Lodash } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('recon/configurationInvoice');

  export default {
    name: 'configuration-invoice-margins',
    data() {
      return {
        title: 'Margem de divergência',
        margin: Lodash.cloneDeep(this.$store.state.recon.configurationInvoice.margin),
      };
    },
    computed: {
      ...mapState([
        'loadingMargin',
        'loadingMarginSave',
      ]),
    },
    watch: {
      margin: {
        handler(margin) {
          this.$store.commit('recon/configurationInvoice/setMargin', margin);
        },
        deep: true,
      },
      '$store.state.recon.configurationInvoice.margin': {
        handler(margin) {
          Object.assign(this.margin, margin);
        },
        deep: true,
      },
    },
    methods: {
      ...mapActions([
        'getMargin',
        'saveMargin',
      ]),
    },
    beforeMount() {
      this.getMargin();
    },
    components: {
      ScField,
      ScInputCurrency,
      ScInputPercent,
      ScRadio,
      ScCard,
    },
  };
</script>

<style lang="scss" scoped>
  .configuration-invoice__radio{
    margin-right: 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/blocks/ConfigurationInvoiceMargins.vue